"use client";

import React from "react";
import BottomButton from "./BottomButton";
import UserIcon from "@/app/_components/Icons/UserIcon";
import UserBoldIcon from "@/app/_components/Icons/UserboldIcon";
import { Box, IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import SideMenu from "../profile/components/SideMenu";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { Roles } from "@/__generated__/graphql";

export default function BottomBarProfile() {
  const { data: session } = useSession();
  const router = useRouter();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const selected = open;
  return (
    <>
      <BottomButton
        selected={selected}
        label="پروفایل"
        icon={<UserIcon />}
        boldIcon={<UserBoldIcon />}
        onClick={() => {
          if (!session) {
            router.push("/login");
          } else if (session.user?.me.roles.includes(Roles.Admin)) {
            router.push("/admin");
          } else {
            setOpen(true);
          }
        }}
      />

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: "70vh",
            borderTopLeftRadius: 4 * 4,
            borderTopRightRadius: 4 * 4,
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          handleClose();
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <Stack sx={{ height: "100%", flexGrow: 1 }}>
          <Stack direction={"row"} sx={{ mt: 1, flexShrink: 0 }} alignItems={"center"} justifyContent={"center"}>
            <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
          </Stack>
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4"> پروفایل</Typography>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <SideMenu handleClose={handleClose} />
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
